const SvgComponent = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={19} fill="none">
    <path
      fill="var(--color-fill-ocr-riepilogo-icons)"
      fillRule="evenodd"
      d="M17.49 9.423c-.282 0-.51.206-.51.46v8.197h-5.473v-5.145c0-.254-.228-.46-.51-.46H7.004c-.282 0-.51.206-.51.46v4.08c0 .253.228.46.51.46.281 0 .51-.207.51-.46v-3.62h2.975v4.685H1.02V6.819L9 1.049l8.171 5.908c.22.159.54.127.717-.071a.43.43 0 0 0-.08-.647L9.319.101a.554.554 0 0 0-.637 0L.191 6.24A.445.445 0 0 0 0 6.598V18.54c0 .254.228.46.51.46h16.98c.282 0 .51-.206.51-.46V9.883c0-.254-.228-.46-.51-.46Z"
      clipRule="evenodd"
    />
  </svg>
)
export { SvgComponent as House }
